<script setup lang="ts">
  import CPSkeleton from '@ui/components/CPSkeleton.vue'

  defineOptions({
    name: 'ConversationCardShimmer',
  })
</script>

<template>
  <div class="conversation-card-shimmer flex w-full items-center gap-3 px-4 py-3">
    <!-- Avatar skeleton -->
    <CPSkeleton type="avatar" width="40px" height="40px" :round="true" />

    <!-- Content skeleton -->
    <div class="flex flex-1 flex-col gap-2">
      <!-- Top row: name and time -->
      <div class="flex items-center justify-between">
        <CPSkeleton width="120px" height="14px" :round="true" />
        <CPSkeleton width="40px" height="12px" :round="true" />
      </div>

      <!-- Bottom row: message preview -->
      <CPSkeleton width="80%" height="12px" :round="true" />
    </div>
  </div>
</template>
